import { useCallback } from 'react';
import { useVersionedCache } from './useVersionedCache';
import { cmsApi, Footer, DEFAULT_FOOTER } from '../services/cmsApi';

/**
 * Nội dung footer (admin quản lý) — cache localStorage gate theo dataVersion + TTL 24h,
 * giống chi-phi / ngành hàng. Luôn trả về Footer (fallback DEFAULT_FOOTER khi chưa tải/lỗi)
 * để footer không bao giờ trống hay làm sập trang.
 */
export function useFooter(): Footer {
  const fetcher = useCallback(async (): Promise<Footer> => {
    const data = await cmsApi.getFooter();
    if (!data) throw new Error('footer rỗng');
    return data;
  }, []);

  const { data } = useVersionedCache<Footer>('tuki_footer_cache', fetcher);
  return data ?? DEFAULT_FOOTER;
}
